interface PageBannerProps {
  title: string;
  subtitle?: string;
  bgImage?: string;
}

export default function PageBanner({ title, subtitle, bgImage }: PageBannerProps) {
  return (
    <section className="relative w-full overflow-hidden h-[320px] md:h-[420px]">
      {bgImage ? (
        <>
          <img
            src={bgImage}
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/25 to-black/50" />
        </>
      ) : (
        <>
          <div className="absolute inset-0 bg-gradient-to-br from-background-50 via-background-50 to-primary-50/40" />
          <div
            className="absolute inset-0 opacity-[0.02]"
            style={{
              backgroundImage: `
                repeating-linear-gradient(0deg, transparent, transparent 60px, oklch(var(--accent-800)) 60px, oklch(var(--accent-800)) 60.5px),
                repeating-linear-gradient(90deg, transparent, transparent 60px, oklch(var(--accent-800)) 60px, oklch(var(--accent-800)) 60.5px)
              `,
            }}
          />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full bg-secondary-500/4 blur-3xl" />
        </>
      )}

      <div className="relative z-10 flex flex-col items-center text-center px-4 py-16 md:py-24 lg:py-28 h-full justify-center">
        <h1 className={`font-heading text-3xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 ${bgImage ? 'text-white' : 'text-accent-800'}`}>
          {title}
        </h1>
        {subtitle && (
          <p className={`text-sm md:text-base leading-relaxed max-w-lg ${bgImage ? 'text-white/80' : 'text-foreground-500'}`}>
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}